<template>
    <div style="padding:12px">
        <div class="top" >
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="content">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="应用模块" prop="moduleId">
                        <el-select @change="queryModelByModuleIdFunc" filterable v-model.trim="formData.moduleId" placeholder="请选择">
                            <el-option v-for="item in moduleList" :key="`${item.id}`" :label="`${item.code}---${item.name}`"
                                       :value="parseInt(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleId">
                        <el-select allow-create filterable v-model.trim="formData.roleId" placeholder="请选择">
                            <el-option v-for="item in roleList" :key="`${item.id}`" :label="item.name"
                                       :value="parseInt(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="角色常量" prop="constantId" v-if="ishide()">
                        <el-input v-model.trim="formData.constantId" placeholder="请输入角色常量"></el-input>
                    </el-form-item>
                    <el-form-item label="选择权限" prop="perList">
                        <div class="tree-container">
                            <el-tree class="filter-tree"
                                     @node-click="nodeClickHandler"
                                     ref="tree"
                                     :data="treeData"
                                     :props="defaultProps"
                                     node-key="id"
                                     :expand-on-click-node='false'
                                     show-checkbox
                            >
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span :title="data.name">{{ data.name }}</span>
                            </span>
                            </el-tree>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';

    import {
        queryModulesBySchoolId,
        queryRoleListBySchoolId,
        insertModuleRole
    } from '@/api/schoolManage';
    import {
        queryModelByModuleId
    } from '@/api/moduleRolePermission';

    export default {
        name: 'moduleRolePermissionAdd',
        data() {
            const validatePerList = (rule, value, callback) => {
                const keys = this.$refs.tree.getCheckedKeys();
                if(keys.filter(key => key != 0).length == 0) {
                    callback(new Error('请选择权限'));
                } else {
                    callback();
                }
            };

            return {
                schoolId: this.$route.query.schoolId,

                moduleList: [],
                roleList: [],
                treeData: [],
                treeSearchText: '',
                defaultProps: {
                    children: 'childrens',
                    label: 'name'
                },
                formData: {
                    moduleId: '',
                    roleId: '',
                    constantId:''
                },
                rules: {
                    moduleId: [
                        { required: true, message: '请选择应用模块', trigger: 'blur' },
                    ],
                    roleId: [
                        { required: true, message: '请选择角色', trigger: 'blur' },
                    ],
                    constantId: [
                        { required: true, message: '请输入角色常量', trigger: 'blur' },
                    ],
                    perList: [
                        { required: true, validator: validatePerList },
                    ]
                },
            }
        },
        components: {BackTool},
        created() {
            Promise.all([
                queryModulesBySchoolId({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.moduleList = data || [];
                        if(data && data.length !== 0) {
                            this.formData.moduleId = data[0].id;
                        }
                    }),
                this.queryRoleListBySchoolIdFunc()
            ])
                .then(() => {
                    this.queryModelByModuleIdFunc();
                })
        },
        methods: {
            ishide(){
               for(let i=0;i<this.roleList.length;i++){
                   if(this.formData.roleId==this.roleList[i].id){
                      return false;
                   }
               }
               return true;
            },
            nodeClickHandler(item) {
                this.$alert(item.t, '权限路径', {
                    confirmButtonText: '确定',

                });
            },
            queryRoleListBySchoolIdFunc() {
                queryRoleListBySchoolId({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.roleList = data || [];
                        if(data && data.length !== 0) {
                            this.formData.roleId = data[0].id;
                        }
                    })
            },
            queryModelByModuleIdFunc() {
                queryModelByModuleId({
                    moduleId: this.formData.moduleId
                })
                    .then(data => {
                        this.treeData = [data];
                    })
            },
            onsave() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const roleObj = this.roleList.find(item => item.id == this.formData.roleId);
                        insertModuleRole({
                            roleName: roleObj ? roleObj.name : this.formData.roleId,
                            moduleId: this.formData.moduleId,
                            perList: [...this.$refs.tree.getCheckedKeys().filter(key => key != 0), ...this.$refs.tree.getHalfCheckedKeys().filter(key => key != 0)].join(','),
                            schoolId: this.schoolId,
                            constantId:this.ishide()?this.formData.constantId:''
                        })
                            .then(() => {
                                this.$message.success('新建成功');
                                setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .tree-container {
        margin-top: 8px;
    }
    .top{
        padding-bottom: 10px;
         border-bottom: 1px solid #e7eaec;
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd.vue